import store from "../store";

export default function academic({ next, router }) {
    if (!store.getters.isAuthenticated) {
        return router.push({ name: "Login" });
    }
    
    if (store.getters["user/user_type"].academic) {
         return router.push({ name: "Search" });
    }
    return next();
}